import {Container} from "react-bootstrap";
import Products from "../components/home/Products";
import elements from "../styles/settings/elements.module.scss";

function ShopPage(){
    return(
        <Container>
            <h1 className={elements.topTitle}>Shop</h1>

            <Products/>
        </Container>
    );
}

export default ShopPage;